// @flow
import { createSelector } from "reselect";
import { getWidgetConfig, getQueueCounters } from "root/selectors";

const getUploadQueue = (state: Object) => state.uploadQueue.queueIds.map((id) => state.uploadQueue.queueItems[id]);

const selectUploadQueueItems: Object => Object[] = createSelector(
	getUploadQueue,
	(queue) => queue,
);

const selectUploadQueueItemIds: Object => string[] = createSelector(
	(state) => state.uploadQueue.queueIds,
	(ids) => ids,
);

const selectCompletedIds: Object => string[] = createSelector(
	getUploadQueue,
	(queue) => queue.reduce((res, item) => ((item.done && !item.failed) ? res.concat(item.id) : res), []),
);

const selectQueueCounters: Object => Object = createSelector(
	(state: Object) => state.uploadQueue,
	getQueueCounters,
);

const selectIsDoneWithSuccess: Object => boolean = createSelector(
	selectQueueCounters,
	(counters) => counters.isDone && !counters.failed,
);

const selectShowCompletedButton: Object => boolean = createSelector(
	getWidgetConfig,
	(config) => config.showCompletedButton,
);

const selectShowUploadMoreButton: Object => boolean = createSelector(
	getWidgetConfig,
	(config) => config.showUploadMoreButton,
);

const selectQueueProgress: Object => number = createSelector(
	getUploadQueue,
	(queue: Object[]) => {
		const progress = queue.reduce((total: number, item: Object) => (total + item.progress), 0);

		return progress && Math.round(progress / queue.length);
	},
);

export {
	selectUploadQueueItemIds,
	selectUploadQueueItems,
	selectQueueCounters,
	selectCompletedIds,
	selectShowCompletedButton,
	selectShowUploadMoreButton,
	selectQueueProgress,
	selectIsDoneWithSuccess,
};
